import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaTelegramPlane,
  FaExchangeAlt
} from "react-icons/fa";

const ContactUs = ({ isDarkMode }) => {
  const [activePlatform, setActivePlatform] = useState("telegram"); // "telegram" or "whatsapp"

  const bg = "transparent";
  const cardBg = isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.9)";
  const text = isDarkMode ? "#f1f5f9" : "#111827";
  const subText = isDarkMode ? "#94a3b8" : "#4b5563";

  const togglePlatform = () => {
    setActivePlatform(prev => prev === "telegram" ? "whatsapp" : "telegram");
  };

  const telegramData = {
    icon: FaTelegramPlane,
    color: "#0088cc",
    bgColor: "rgba(0,136,204,0.1)",
    title: "Chat with us on Telegram",
    description: "Click the button below to instantly start a conversation with our team.",
    buttonText: "Open Telegram",
    buttonLink: "https://t.me/pyruxsupport",
    badge: "24/7 Active • Instant Reply"
  };

  const whatsappData = {
    icon: FaWhatsapp,
    color: "#25D366",
    bgColor: "rgba(37,211,102,0.1)",
    title: "Chat with us on WhatsApp",
    description: "Click the button below to instantly start a conversation with our team on WhatsApp.",
    buttonText: "Open WhatsApp",
    buttonLink: "https://wa.me/8801984831657",
    badge: "24/7 Active • Instant Reply"
  };

  const currentData = activePlatform === "telegram" ? telegramData : whatsappData;
  const CurrentIcon = currentData.icon;
  const OtherIcon = activePlatform === "telegram" ? FaWhatsapp : FaTelegramPlane;
  const otherColor = activePlatform === "telegram" ? "#25D366" : "#0088cc";

  return (
    <section
      id="contactus"
      style={{
        padding: "100px 20px",
        background: bg,
        color: text,
        transition: "0.4s",
        position: "relative",
        zIndex: 20
      }}
    >
      {/* HEADER */}
      <div
        style={{
          textAlign: "center",
          maxWidth: "800px",
          margin: "0 auto 60px",
        }}
      >
        <h2 style={{ fontSize: "42px", marginBottom: "12px" }}>
          Contact Us
        </h2>
        <p style={{ color: subText, lineHeight: "1.7" }}>
          Have a project idea or business inquiry?
          Feel free to reach out to us and our team will respond quickly.
        </p>
      </div>

      {/* GRID */}
      <div
        style={{
          maxWidth: "1100px",
          margin: "auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "40px",
        }}
      >
        {/* CONTACT INFO - Left Column (Unchanged) */}
        <div
          style={{
            background: cardBg,
            padding: "40px",
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            position: "relative",
            zIndex: 20
          }}
        >
          <h3 style={{ marginBottom: "30px" }}>Contact Information</h3>

          <div style={{ marginBottom: "25px", display: "flex", gap: "15px" }}>
            <FaPhoneAlt color="#ef4444" size={20} />
            <div>
              <strong>Phone</strong>
              <p style={{ color: subText }}>+8801984831657</p>
            </div>
          </div>

          <div style={{ marginBottom: "25px", display: "flex", gap: "15px" }}>
            <FaEnvelope color="#6366f1" size={20} />
            <div>
              <strong>Email</strong>
              <p style={{ color: subText }}>pyruxsupport@gmail.com</p>
            </div>
          </div>

          <div style={{ marginBottom: "25px", display: "flex", gap: "15px" }}>
            <FaMapMarkerAlt color="#10b981" size={20} />
            <div>
              <strong>Location</strong>
              <p style={{ color: subText }}>Dhaka, Bangladesh</p>
            </div>
          </div>

          <div style={{ marginBottom: "25px", display: "flex", gap: "15px" }}>
            <FaWhatsapp color="#25D366" size={22} />
            <div>
              <strong>WhatsApp</strong>
              <p style={{ color: subText }}>+8801984831657</p>
            </div>
          </div>

          <div style={{ display: "flex", gap: "15px" }}>
            <FaTelegramPlane color="#0088cc" size={22} />
            <div>
              <strong>Telegram</strong>
              <p style={{ color: subText }}>@pyrux_support</p>
            </div>
          </div>
        </div>

        {/* DYNAMIC CONTACT CARD - Right Column with Switch */}
        <div
          style={{
            background: cardBg,
            padding: "40px",
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            gap: "20px",
            position: "relative",
            zIndex: 20
          }}
        >
          {/* Dual Icon Display with Switch */}
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "10px"
            }}
          >
            {/* Main Icon (Active Platform) */}
            <div
              style={{
                transition: "all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                animation: activePlatform === "telegram" ? "slideInLeft 0.5s ease-out" : "slideInRight 0.5s ease-out",
                zIndex: 2
              }}
            >
              <CurrentIcon
                size={90}
                color={currentData.color}
                style={{
                  background: currentData.bgColor,
                  padding: "25px",
                  borderRadius: "50%",
                  boxShadow: `0 10px 30px ${currentData.color}40`,
                  transition: "all 0.3s ease"
                }}
              />
            </div>

            {/* Background Icon (Inactive Platform) */}
            <div
              style={{
                position: "absolute",
                opacity: 0.3,
                transition: "all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                transform: activePlatform === "telegram" ? "translateX(-40px) scale(0.7)" : "translateX(40px) scale(0.7)",
                zIndex: 1
              }}
            >
              <OtherIcon
                size={70}
                color={otherColor}
                style={{
                  background: "rgba(0,0,0,0.05)",
                  padding: "20px",
                  borderRadius: "50%",
                  transition: "all 0.3s ease"
                }}
              />
            </div>
          </div>

          {/* Switch Button */}
          <button
            onClick={togglePlatform}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              background: isDarkMode ? "rgba(255,255,255,0.1)" : "#f1f5f9",
              padding: "10px 24px",
              borderRadius: "50px",
              border: "none",
              cursor: "pointer",
              transition: "all 0.3s ease",
              marginTop: "10px",
              marginBottom: "10px"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = isDarkMode ? "rgba(255,255,255,0.2)" : "#e2e8f0";
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = isDarkMode ? "rgba(255,255,255,0.1)" : "#f1f5f9";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <FaTelegramPlane 
              size={18} 
              color={activePlatform === "telegram" ? "#0088cc" : subText}
              style={{
                transition: "all 0.3s ease",
                opacity: activePlatform === "telegram" ? 1 : 0.5
              }}
            />
            <FaExchangeAlt size={14} color={subText} />
            <FaWhatsapp 
              size={18} 
              color={activePlatform === "whatsapp" ? "#25D366" : subText}
              style={{
                transition: "all 0.3s ease",
                opacity: activePlatform === "whatsapp" ? 1 : 0.5
              }}
            />
            <span style={{
              fontSize: "12px",
              color: subText,
              marginLeft: "5px"
            }}>
              Switch to {activePlatform === "telegram" ? "WhatsApp" : "Telegram"}
            </span>
          </button>

          {/* Title with Animation */}
          <h3
            style={{
              animation: activePlatform === "telegram" ? "fadeInLeft 0.5s ease-out" : "fadeInRight 0.5s ease-out",
              margin: 0
            }}
          >
            {currentData.title}
          </h3>

          {/* Description */}
          <p
            style={{
              color: subText,
              maxWidth: "260px",
              animation: activePlatform === "telegram" ? "fadeInLeft 0.6s ease-out" : "fadeInRight 0.6s ease-out"
            }}
          >
            {currentData.description}
          </p>

          {/* Badge */}
          <div
            style={{
              background: "linear-gradient(90deg, #22c55e, #16a34a)",
              color: "#fff",
              padding: "8px 18px",
              borderRadius: "50px",
              fontWeight: "600",
              fontSize: "14px",
              boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
              animation: activePlatform === "telegram" ? "fadeInLeft 0.7s ease-out" : "fadeInRight 0.7s ease-out"
            }}
          >
            {currentData.badge}
          </div>

          {/* Action Button */}
          <a
            href={currentData.buttonLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              marginTop: "10px",
              padding: "12px 28px",
              borderRadius: "30px",
              background: currentData.color,
              color: "#fff",
              textDecoration: "none",
              fontWeight: "600",
              transition: "all 0.3s ease",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              animation: activePlatform === "telegram" ? "fadeInLeft 0.8s ease-out" : "fadeInRight 0.8s ease-out"
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.05)";
              e.target.style.boxShadow = `0 10px 25px ${currentData.color}80`;
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
              e.target.style.boxShadow = "none";
            }}
          >
            <CurrentIcon size={18} />
            {currentData.buttonText}
          </a>
        </div>
      </div>

      {/* CSS Animations */}
      <style>
        {`
          @keyframes slideInLeft {
            from {
              opacity: 0;
              transform: translateX(-50px) scale(0.8);
            }
            to {
              opacity: 1;
              transform: translateX(0) scale(1);
            }
          }

          @keyframes slideInRight {
            from {
              opacity: 0;
              transform: translateX(50px) scale(0.8);
            }
            to {
              opacity: 1;
              transform: translateX(0) scale(1);
            }
          }

          @keyframes fadeInLeft {
            from {
              opacity: 0;
              transform: translateX(-20px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes fadeInRight {
            from {
              opacity: 0;
              transform: translateX(20px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
        `}
      </style>
    </section>
  );
};

export default ContactUs;